"use server";

import { cookies } from "next/headers";
import { redirect } from "next/navigation";
import {
  ADMIN_SESSION_COOKIE,
  getSessionSecret,
  signAdminSessionPayload,
} from "@/lib/admin-session";

export type LoginState = { error?: string } | null;

export async function loginAction(_prev: LoginState, formData: FormData): Promise<LoginState> {
  const username = String(formData.get("username") ?? "").trim();
  const password = String(formData.get("password") ?? "");

  const expectUser = (process.env.ADMIN_USERNAME || "").trim();
  const expectPass = process.env.ADMIN_PASSWORD ?? "";
  const sessionSecret = (await getSessionSecret()).trim();

  if (!expectUser || !expectPass) {
    return { error: "Server is missing ADMIN_USERNAME / ADMIN_PASSWORD." };
  }
  if (!sessionSecret) {
    return { error: "Server is missing ADMIN_SESSION_SECRET." };
  }

  if (username !== expectUser || password !== expectPass) {
    return { error: "Invalid username or password." };
  }

  const token = await signAdminSessionPayload(sessionSecret, 60 * 60 * 12);
  const jar = await cookies();
  jar.set(ADMIN_SESSION_COOKIE, token, {
    httpOnly: true,
    secure: process.env.NODE_ENV === "production",
    sameSite: "lax",
    path: "/",
    maxAge: 60 * 60 * 12,
  });

  redirect("/users");
}

export async function logoutAction() {
  const jar = await cookies();
  jar.delete(ADMIN_SESSION_COOKIE);
  redirect("/login");
}
